/* 720 · Nue "Aramızda Kalsın" (Kasım 2026) — kampanya.py kurar, bitir söker.
   1) Duyuru çubuğu: "Bu gece uzun." yazan mesaja İstanbul'un o geceki süresi yazılır (gün batımı/doğumu tarayıcıda hesaplanır).
   2) Ürün sayfası "ikilisi": siparişlerde birlikte alınan parça (yoksa Shopify'ın benzer ürün önerisi), iki parça %10 ile tek tıkla sepete. */
(() => {
  if (Date.now() > Date.UTC(2026, 10, 30, 20, 59, 59)) return;
  const root = window.Shopify?.routes?.root || '/';
  const tl = k => new Intl.NumberFormat('tr-TR', {style: 'currency', currency: 'TRY', maximumFractionDigits: 0}).format(Math.round(k / 100));

  function geceDakika(d) {
    const lat = 41.01, rad = Math.PI / 180;
    const n = Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 864e5), g = 2 * Math.PI / 365 * (n - 1);
    const de = 0.006918 - 0.399912 * Math.cos(g) + 0.070257 * Math.sin(g) - 0.006758 * Math.cos(2 * g) + 0.000907 * Math.sin(2 * g) - 0.002697 * Math.cos(3 * g) + 0.00148 * Math.sin(3 * g);
    const ha = Math.acos(Math.cos(90.833 * rad) / (Math.cos(lat * rad) * Math.cos(de)) - Math.tan(lat * rad) * Math.tan(de)) / rad;
    return 1440 - 8 * ha;
  }
  function gece() {
    const m = Math.round(geceDakika(new Date()));
    document.querySelectorAll('.announcement-bar__message span').forEach(s => {
      if (s.textContent.trim().startsWith('Bu gece uzun')) s.textContent = `Bu gece İstanbul'da ${Math.floor(m / 60)} saat ${m % 60} dakika. Aramızda kalsın.`;
    });
    // en üstteki kayan şerit: "BU GECE UZUN" → o geceki süre
    document.querySelectorAll('.nue-marquee-track').forEach(t => {
      const w = document.createTreeWalker(t, NodeFilter.SHOW_TEXT);
      for (let n; (n = w.nextNode());) if (n.nodeValue.includes('BU GECE UZUN')) n.nodeValue = n.nodeValue.replace('BU GECE UZUN', `BU GECE İSTANBUL'DA ${Math.floor(m / 60)} SAAT ${m % 60} DAKİKA`);
    });
  }

  const urunJs = h => fetch(`${root}products/${h}.js`).then(r => r.ok ? r.json() : null);
  async function ikiliKur(el) {
    const kutu = el.querySelector('.k720-ikili');
    let ana = await urunJs(el.dataset.handle), es = null;
    if (!ana) return;
    if (el.dataset.ikili) es = await urunJs(el.dataset.ikili);
    if (!es || !es.available) {
      const r = await fetch(`${root}recommendations/products.json?product_id=${el.dataset.productId}&limit=6&intent=related`).then(r => r.json()).catch(() => null);
      es = (r?.products || []).find(p => p.available && p.handle !== ana.handle) || null;
    }
    if (!es) return;
    const form = document.querySelector('product-info form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"][id^="product-form"] input[name="id"]');
    const anaV = () => ana.variants.find(v => String(v.id) === String(form?.value)) || ana.variants.find(v => v.available) || ana.variants[0];
    const tekBeden = es.variants.length === 1;
    let secili = null;
    const eslestir = () => {
      const a = anaV(), ad = (a.option1 || '').toLowerCase();
      const ayni = es.variants.find(v => v.available && (v.option1 || '').toLowerCase() === ad);
      if (!secili || !secili.available) secili = ayni || es.variants.find(v => v.available) || es.variants[0];
    };
    const ciz = () => {
      eslestir();
      const a = anaV(), top = a.price + secili.price, ind = Math.round(top * 0.9);
      const fi = es.featured_image || '', img = fi + (fi.includes('?') ? '&' : '?') + 'width=200';
      kutu.innerHTML =
        `<div class="k720-ikili-kart"><a href="${es.url}"><img src="${img}" alt="${es.title.replace(/"/g, '&quot;')}" loading="lazy" width="76" height="114"></a><div>` +
        `<p class="k720-fisilti">ikilisi</p><a class="k720-ikili-ad" href="${es.url}">${es.title}</a>` +
        `<p class="k720-ikili-fiyat">İkisi birlikte <b>${tl(ind)}</b><s>${tl(top)}</s></p>` +
        (tekBeden ? '' : `<div class="k720-ikili-beden" role="group" aria-label="İkilinin bedeni">${es.variants.map(v => `<button type="button" data-v="${v.id}" aria-pressed="${v.id === secili.id}" ${v.available ? '' : 'disabled'}>${v.title}</button>`).join('')}</div>`) +
        `</div></div><button type="button" class="k720-ikili-btn">İkiliyi sepete ekle</button><p class="k720-ikili-hata" role="alert"></p>`;
      kutu.hidden = false;
    };
    kutu.addEventListener('click', async e => {
      const b = e.target.closest('[data-v]');
      if (b) { secili = es.variants.find(v => String(v.id) === b.dataset.v); ciz(); return; }
      const btn = e.target.closest('.k720-ikili-btn');
      if (!btn) return;
      btn.disabled = true;
      const a = anaV(), cd = document.querySelector('cart-drawer');
      try {
        const r = await fetch(`${root}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: a.id, quantity: 1}, {id: secili.id, quantity: 1}], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})}).then(r => r.json());
        if (r.status) throw new Error(r.description || r.message);
        if (cd && r.sections) cd.renderContents(r); else location.assign(`${root}cart`);
      } catch (err) { kutu.querySelector('.k720-ikili-hata').textContent = err.message || 'Sepete eklenemedi'; }
      btn.disabled = false;
    });
    document.addEventListener('change', e => { if (e.target.closest('product-info, variant-selects')) setTimeout(ciz, 120); });
    ciz();
  }

  const basla = () => { gece(); document.querySelectorAll('[data-k720-urun]').forEach(el => ikiliKur(el).catch(() => {})); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', basla) : basla();
})();
